import {
  Box,
  Button,
  Flex,
  Icon,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { CheckCircleIcon, TimeIcon } from "@chakra-ui/icons";
import { RotateCcw } from "lucide-react";
import { IconButton, Tooltip } from "@chakra-ui/react";
import { ChildrenInteractionBlocker } from "../../../../components/overlays/ChildrenInteractionBlocker";
import { PERMISSIONS } from "../../../../config/permissions";
import type { MissionItem } from "../../../../types/onboarding";

export interface MissionListItemProps {
  mission: MissionItem;
  index: number;
  isLast: boolean;
  onClick: () => void;
  onApprove?: () => void;
  isApproving?: boolean;
  onReset?: () => void;
  isResetting?: boolean;
}

export const MissionListItem = ({ mission, index, isLast, onClick, onReset, isResetting }: MissionListItemProps) => {
  const titleCompletedColor = useColorModeValue("gray.800", "white");
  const rowBorderColor      = useColorModeValue("gray.100", "whiteAlpha.200");
  const hoverBg             = useColorModeValue("gray.50", "whiteAlpha.100");

  const iconColor  = mission.waiting_rh ? "orange.400" : mission.completed ? "green.500" : "gray.300";
  const titleColor = mission.waiting_rh ? "orange.700" : mission.completed ? titleCompletedColor : "gray.500";
  const subColor   = mission.waiting_rh ? "orange.400" : mission.completed ? "green.500" : "gray.400";
  const subLabel   = mission.waiting_rh
    ? "Aguardando aprovação do RH"
    : mission.completed
    ? "Concluída — clique para visualizar"
    : "Pendente";

  const canReset = mission.completed || mission.waiting_rh;

  return (
    <Flex
      align="center"
      gap={3}
      py={3}
      borderBottomWidth={isLast ? 0 : "1px"}
      borderColor={rowBorderColor}
      cursor="pointer"
      borderRadius="md"
      px={2}
      mx={-2}
      _hover={{ bg: hoverBg }}
      onClick={onClick}
      role="button"
    >
      <Icon
        as={mission.waiting_rh ? TimeIcon : mission.completed ? CheckCircleIcon : TimeIcon}
        color={iconColor}
        boxSize={5}
        flexShrink={0}
      />
      <Box flex={1}>
        <Text fontSize="sm" fontWeight="medium" color={titleColor}>{mission.title}</Text>
        <Text fontSize="xs" color={subColor}>{subLabel}</Text>
      </Box>
      {canReset && onReset && (
        <ChildrenInteractionBlocker
          requiredPermissions={[PERMISSIONS.RH.RESET_MISSIONS]}
          toastMessage="Você não tem permissão para resetar missões."
        >
          <Tooltip label="Resetar missão" fontSize="xs">
            <IconButton
              aria-label="Resetar missão"
              icon={<Icon as={RotateCcw} boxSize={3.5} />}
              size="xs"
              variant="ghost"
              colorScheme="red"
              isLoading={isResetting}
              onClick={(e) => { e.stopPropagation(); onReset(); }}
            />
          </Tooltip>
        </ChildrenInteractionBlocker>
      )}
    </Flex>
  );
};
